import { render } from "./GimItemTypeAdmin.vue?vue&type=template&id=68b7f14d"
import script from "./GimItemTypeAdmin.vue?vue&type=script&lang=js"
export * from "./GimItemTypeAdmin.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__